import type { DataFetchParams } from '@/components/DataTable';
import { USER_SECURITY_POSTURE_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/user-security-posture';

const ENDPOINTS_FIELD = USER_SECURITY_POSTURE_FILTERABLE_FIELDS.ENDPOINTS;
/** The Endpoints column sorts by endpoint count (`sortField: 'endpointCount'`). */
const ENDPOINT_COUNT_SORT_FIELD = 'endpointCount';

/**
 * KIR-3035: strip the Endpoints column's persisted filter (`endpoints`) and
 * sort (`endpointCount`) when the `endpoint_identifier` flag is off, so a
 * leftover URL can't filter/sort the Inventory→Users table by endpoint identity
 * while the column is hidden. Mirrors `sanitizeAlertsParams`; applied to BOTH
 * the query key and the request so the cache key stays stable too.
 */
export function sanitizeUspParams(
  params: DataFetchParams,
  endpointsColumnEnabled: boolean
): DataFetchParams {
  if (endpointsColumnEnabled) return params;
  const filters = params.filters.filter(f => f.field !== ENDPOINTS_FIELD);
  const sort =
    params.sort?.field === ENDPOINT_COUNT_SORT_FIELD ? undefined : params.sort;
  return { ...params, filters, sort };
}
